import React from 'react';
import { twMerge } from 'tailwind-merge';
import ApiImage from './ApiImage';
import { getInitials } from '../../utils/stringUtils';

interface AvatarProps {
  src: string | undefined;
  alias: string;
  className?: string;
}
export default function Avatar({ src, alias, className }: AvatarProps): JSX.Element {
  return src ? (
    <ApiImage
      src={src}
      alt={alias}
      className={twMerge('h-10 w-10 flex-shrink-0 rounded-full object-cover', className)}
    />
  ) : (
    <div
      className={twMerge(
        'flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-secondary-200 text-sm font-medium text-primary',
        className,
      )}>
      {getInitials(alias)}
    </div>
  );
}
